import type { LoomWingSectionSide } from "./loomSectionRecipe";

type EditPathSegment =
  | { kind: "field"; name: string }
  | { kind: "panel"; panelId: string }
  | { kind: "station"; stationId: string }
  | { kind: "index"; index: number };

type MutableRecipe = Record<string, unknown>;
type MutablePanel = { panelId?: unknown; sectionRecipes?: Partial<Record<LoomWingSectionSide, MutableRecipe>> };

function editedSection(path: readonly EditPathSegment[]): { panelId: string; side: LoomWingSectionSide } | null {
  const panelIndex = path.findIndex((segment) => segment.kind === "panel");
  if (panelIndex < 0) return null;
  const panelSegment = path[panelIndex];
  if (panelSegment?.kind !== "panel") return null;
  const airfoil = path.slice(panelIndex + 1).find((segment) => segment.kind === "field" && (segment.name === "airfoilRoot" || segment.name === "airfoilTip"));
  if (airfoil?.kind !== "field") return null;
  return { panelId: panelSegment.panelId, side: airfoil.name === "airfoilRoot" ? "root" : "tip" };
}

/** Remove only provenance made stale by an explicit base-airfoil edit. */
export function invalidateEditedLoomSectionTreatments(root: unknown, paths: readonly (readonly EditPathSegment[])[]): void {
  if (typeof root !== "object" || root === null || (root as { primitive?: unknown }).primitive !== "wing") return;
  const panels = (root as { panels?: unknown }).panels;
  if (!Array.isArray(panels)) return;
  paths.forEach((path) => {
    const target = editedSection(path);
    if (!target) return;
    const panel = panels.find((candidate): candidate is MutablePanel => typeof candidate === "object" && candidate !== null && (candidate as MutablePanel).panelId === target.panelId);
    if (!panel) return;
    const recipes = panel.sectionRecipes;
    const recipe = recipes?.[target.side];
    if (!recipe || !("treatment" in recipe)) return;
    const preserved = { ...recipe };
    delete preserved.treatment;
    panel.sectionRecipes = { ...recipes, [target.side]: preserved };
  });
}
